import type {} from '@redux-devtools/extension' 
import Questionizer from './components/questionizer';
import { useEffect } from 'react';
import { useQuestionizerStore } from './types/state';
import { TranslationMap } from './translation';

export default function App(props: {className?: string, configPath: string | null | undefined, translation_map?: TranslationMap}) {
  const config = useQuestionizerStore((state) => state.config);
  const loadConfig = useQuestionizerStore((state) => state.loadConfig);
  const requestStatistics = useQuestionizerStore((state) => state.requestStatistics);
  const setTranslationMap = useQuestionizerStore((state) => state.setTranslationMap);

  const sendStatisticsInterval = 3000; //3 seconds
  useEffect(()=>{
    if(!props.configPath){return;}
    if (config){ return; } 
    loadConfig(props.configPath);
    setTranslationMap(props.translation_map);
    requestStatistics();
    const interval = setInterval(()=>{
      requestStatistics();
    }, sendStatisticsInterval);
    return ()=>{clearInterval(interval)};
  },[]);

  if (!props.configPath || !config) { return; }

  const style = config.style;
  const parsed_style = style ? Object.keys(style)
    .map(selector => {
      const prefixed = selector === ''
        ? '.questionizer-root'
        : selector.split(',').map(s => '.questionizer-root ' + s.trim()).join(', ');
      const props = Object.entries(style[selector])
        .map(([k, v]) => `${k}:${v}`)
        .join(';');
      return `${prefixed}{${props}}`;
    })
    .join(' ') : '';

    return <>
        <style>{parsed_style}</style>
        <Root className={props.className}/>
    </>
  }

function Root(props: {className?: string}){
  return <div className={"questionizer-root questionizer-container w-full h-full flex flex-col font-sans "+(props.className || "")}>
      <Questionizer />
  </div>
}